import { FC } from 'react'
import { ContractChangePayload } from '../types'
import { CareerPathEvaluation, LatestContractDtoFragment } from '../../../../types'
import { CareerPathPopover } from '../../../../components/custom_components/CarrerPathPopover/CareerPathPopover'
import { LoadingAndErrors } from '../../../../components/custom_components/LoadingAndErrors'
import { useTranslation } from 'react-i18next'
import { useGetCareerPathData } from '../../../../graphql/career-path/hooks/useGetCareerPathData'
import PerFlexRow from '../../../../components/custom_components/FlexRow'
import PerText from '../../../../components/custom_components/Text'
import { ContractChangeCareerPathRow } from '../formik/ContractChangeCareerPathRow'
import { createCareerPathEvaluation, filterCareerPathReferencesByLevel } from './careerpath-util'

type ContractChangeCareerPathType = {
  careerPathEvaluation: CareerPathEvaluation
  formValues: ContractChangePayload
  currentContract: LatestContractDtoFragment
  isPreparation?: boolean
}

export const ContractChangeCareerPath: FC<ContractChangeCareerPathType> = ({
  careerPathEvaluation,
  formValues,
  currentContract,
  isPreparation = false,
}) => {
  const [t] = useTranslation()
  const { data, error, loading } = useGetCareerPathData(currentContract.legalEntity.country)

  if (!data || !data.careerPath || error || loading) {
    return <LoadingAndErrors error={error} isLoading={loading} />
  }
  const referencesForCurrentContract = currentContract.employeeLevel
    ? filterCareerPathReferencesByLevel(data.careerPath, currentContract.employeeLevel.level)
    : null
  const referencesForContractChanges = formValues.employeeLevel
    ? filterCareerPathReferencesByLevel(data.careerPath, formValues.employeeLevel)
    : referencesForCurrentContract

  const newCareerPath = createCareerPathEvaluation(formValues, currentContract, data.careerPath)

  return (
    <ContractChangeCareerPathRow
      label="careerPath"
      current={
        !!careerPathEvaluation &&
        referencesForCurrentContract && (
          <PerFlexRow>
            <PerText mr="xxs">{t(`appraisalMeeting.contract.changes.change.careerPathSummary`)}</PerText>
            <CareerPathPopover
              careerPath={careerPathEvaluation}
              bonusReference={referencesForCurrentContract.bonus}
              salaryReference={referencesForCurrentContract.salary}
              currency={currentContract.currencyForPayments}
            />
          </PerFlexRow>
        )
      }
      change={
        !!referencesForContractChanges &&
        !!newCareerPath && (
          <PerFlexRow>
            <PerText mr="xxs">{t(`appraisalMeeting.contract.changes.change.careerPathSummary`)}</PerText>
            <CareerPathPopover
              careerPath={newCareerPath}
              bonusReference={referencesForContractChanges.bonus}
              salaryReference={referencesForContractChanges.salary}
              currency={currentContract.currencyForPayments}
            />
          </PerFlexRow>
        )
      }
      isPreparation={isPreparation}
    />
  )
}
